import { ViewController, ButtonView, ButtonViewDelegate, GuiResizeEvent, GuiSwitchEvent, ButtonClickEvent } from "@gaming/srvg-classes-core";

export class GuiSwitchController extends ViewController implements ButtonViewDelegate {
    public name: string;
    wrapper: string;
    button: ButtonView;
    compactClass: string;
    skillClass: string;
    _$wrapper: any;
    _wrapperDimension: any;

    constructor(options) {
        options = options || {};
        options.view = options.button || null;
        super( options );

        this.name = 'guiSwitchController';

        this.wrapper        = options.wrapper || '#wrapper';
        this.button         = options.button || null;
        this.compactClass   = options.compactClass || 'compact_view';
        this.skillClass     = options.skillClass   || 'skill_view';

        this._$wrapper      = $(this.wrapper);

        this._wrapperDimension = {
            height: 0,
            width: 0
        };

        var that = this;
        /*
        // not needed at the moment, because we have no switch of the gui and a responsible layout
        $(window).resize(function (that) {
            return function() {
                console.log("resize Window");
                that.handleWindowResize();
                return this;
            };
        });*/

        this.button.setDelegate( this );

        // toggle functionality for collapsed view
        options.shouldToggleContainer = options.shouldToggleContainer || false;
        if (options.shouldToggleContainer){
            $('.toggle-button').click(function(){
                that.toggleContainer($(this));
            });
        }

        this.generatedEvents.push( GuiResizeEvent );
        this.generatedEvents.push( GuiSwitchEvent );
    }

    /*handleWindowResize() {
    // not needed at the moment, because we have no switch of the gui and a responsible layout
        var newHeight = this._$wrapper.height(),
            newWidth  =  this._$wrapper.width();

        // if resize event was triggered, but no width changes was occured on the wrapper
        if (this._wrapperDimension.height === newHeight && this._wrapperDimension.width === newWidth) {
            return;
        }

        this._wrapperDimension.height = newHeight;
        this._wrapperDimension.width = newWidth;
        this.triggerEvent( new GuiResizeEvent( newWidth, newHeight ) );
    }*/

    handleButtonClickEvent( event:ButtonClickEvent, provider ) {
        var before = 'compact',
            after  = 'skill';
        if (!this._$wrapper.hasClass(this.compactClass)){
            before = 'skill';
            after  = 'compact';
        }

        // pitfall: uses switchClass, cause for the event which is too fast,
        // if you have no complete-callback as in removeClass and addClass
        $(this._$wrapper).switchClass(this[before+'Class'], this[after+'Class'], 0, 'swing', function(that){
            return function() {
                // trigger gui resize element for customer integration to change iframe height for example
                // uses set timeout to set in another context, otherwise the height isn't set yet
                setTimeout(function() {
                    var newHeight = that._$wrapper.height(),
                        newWidth  =  that._$wrapper.width();
                    that.triggerEvent( new GuiResizeEvent( newWidth, newHeight ) );
                },1);

            };
        }(this));

        // trigger gui switch event for widgets and elements to give the chance to change
        this.triggerEvent(
            new GuiSwitchEvent(this._$wrapper, before, this[before+'Class'], after, this[after+'Class'])
        );
    }

    toggleContainer ($element){
        if (
            // check data attribute or element exists
            typeof $element.attr('data-toggle-container') !== "undefined"
            // and is filled with something
            && $element.attr('data-toggle-container') !== ""
        ){

            var that = this;

            // fetch element name from data-toggle-container-attribute
            var container = $element.attr('data-toggle-container');
            // parse it into a jquery object
            var $container = $(container);
            // if a container exists
            if ($container.length > 0){
                // collapse / expand whole view
                $container.slideToggle(400, function(){
                    $element.toggleClass('closed');
                    $container.toggleClass('closed');
                    //that.handleWindowResize();
                });
            }
        }
        return false;
    }

}